import axios from 'axios';
import Cookies from 'js-cookie';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

const logRequestUrl = (config) => {
  if (process.env.NODE_ENV !== 'development') {
    return;
  }

  const base = (config.baseURL || '').replace(/\/$/, '');
  const path = (config.url || '').replace(/^\//, '');
  const fullUrl = path ? `${base}/${path}` : base;
  console.log(`[API] ${(config.method || 'get').toUpperCase()} ${fullUrl}`);
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get('accessToken'); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    logRequestUrl(config);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error('Unauthorized, logging out ...');
      Cookies.remove('accessToken');
      // Cookies.remove('refreshToken');
      
      const signInPath = "/auth/signin";

      if (window.location.pathname !== signInPath) {
        window.location.assign(signInPath);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
